var deprecate = require("util-deprecate");
module.exports = deprecate(
  require("sprintf-js").sprintf,
  "sprintf() will be removed in the next major release, use the sprintf-js package instead."
);
